export const tailMisc = {
  tabBottom: {
    checkins: `Check-in`,
    checkinsProg: `Prossimi`,
    requests: `Richieste`,
  },
  adminNav: {
    myAccount: `Il mio account`,
  },
  loader: {
    title: `Creazione {reason}!`,
    defaultReason: `alloggio`,
    preparing: `Stiamo preparando il tuo {reason}, attendi…`,
    calendar: `Configurazione del calendario`,
    availability: `Verifica della disponibilità`,
    prices: `Configurazione dei prezzi`,
    almostDone: `Quasi fatto, stiamo completando il tuo {reason}…`,
  },
};
